import { combineReducers } from 'redux';
import convReduce from './conv';
import * as UI_TYPES from '../actions/ui';
import * as AUTH_TYPES from '../actions/auth';
import * as GROUP_TYPES from '../actions/group';
import * as PM_TYPES from '../actions/pm';
import * as USER_TYPES from '../actions/user';
import * as UPLOADER_TYPES from '../actions/uploader';
import * as SYSTEM_TYPES from '../actions/system';
import { APP_TABS, GROUP_TABS, SETTINGS_ITEMS } from 'constants';
import { storage } from 'utils';
import { loadAndWatchReducer } from './load_and_watch';
import { isWeb } from 'core';

const initial = {
  conv: { list: [] },
  ui: {
    selected_app_tab: APP_TABS.GROUPS,
    selected_group_tab: isWeb ? GROUP_TABS.ANNOUNCEMENTS : GROUP_TABS.CHAT,
    selected_settings_item: isWeb ? SETTINGS_ITEMS.ACCOUNT : null,
    route_index: 0
  },
  fetch: {}
};
const reduce = (state, action, prefix, TYPES) => {
  let splits = action.type.split('.');
  if (splits[0] !== prefix) {
    return state;
  }

  if (splits[0] === 'CONV') {
    return convReduce(state, action);
  }

  if (splits[0] === 'GROUP' || splits[0] === 'AUTH' || splits[0] === 'UPLOADER') {
    return loadAndWatchReducer(state, action, action.attr_name);
  }

  if (splits[0] === 'FETCH') {
    return { ...state, ...action.payload };
  }

  if (splits[0] === prefix && TYPES[splits[1]] && action.payload) {
    return { ...state, ...action.payload };
  }
  return state;
};

const conv = (state = initial.conv, action) => reduce(state, action, 'CONV');
const ui = (state = initial.ui, action) => reduce(state, action, 'UI', UI_TYPES);
const auth = (state = {}, action) => reduce(state, action, 'AUTH', AUTH_TYPES);
const group = (state = {}, action) => reduce(state, action, 'GROUP', GROUP_TYPES);
const pm = (state = {}, action) => reduce(state, action, 'PM', PM_TYPES);
const user = (state = {}, action) => reduce(state, action, 'USER', USER_TYPES);
const fetch = (state = initial.fetch, action) => reduce(state, action, 'FETCH');
const uploader = (state = {}, action) => reduce(state, action, 'UPLOADER', UPLOADER_TYPES);
const system = (state = {}, action) => reduce(state, action, 'SYSTEM', SYSTEM_TYPES);

const AppReducer = combineReducers({ user, conv, ui, fetch, uploader, auth, group, pm, system });

const RootReducer = (state, action) => {
  if (action.type === 'AUTH.LOGOUT') {
    state = { ...initial };
    state.ui.show_login = true;
    return state;
  }
  const new_state = AppReducer(state, action);
  if(action.type === USER_TYPES.SET_USER ){
    storage.set('cached_user',new_state.user)
  } else if (action.type.includes('AUTH.') && action.type.includes('SESSIONS')){
    storage.set('cached_sessions',new_state.auth.list.sessions)
  }

  return new_state
};

export default RootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js